// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#aw--c #aw-sl .moment-focus{background-color:#f1d9ff!important}#aw--c #aw-sl .moment-transition{transition:background-color .5s linear!important;-moz-transition:background-color .5s linear!important;-webkit-transition:background-color .5s linear!important;-ms-transition:background-color .5s linear!important}", ""]);
// Exports
module.exports = exports;
